<br />
<div class="row">
  <div class="col-md-10 offset-md-3 text-left col-12">
    <h1 class="title">
      <span *ngIf="isOdpSupervisor">MANAGE RECONCILIATION TEAMS: <strong>{{activeProjectTitle}}</strong></span>
      <span *ngIf="!isOdpSupervisor">MANAGE QC TEAMS: <strong>{{activeProjectTitle}}</strong></span>
    </h1>
  </div>
</div>
<br />
<div class="row">
  <div class="col-lg-4 offset-lg-3 col-12 mb-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-xl-8 tm-header col-12">
            <div class="font-weight-bold">Available Team Members</div>
            <div *ngIf="users?.length; else noUsers">Click a name to select a team member.</div>
            <ng-template #noUsers>No free team members currently exist.</ng-template>
          </div>
          <div *ngIf="users?.length" class="col-xl-4 tm-header col-12">
            <button type="submit" class="btn float-right"
                    [ngClass]="selectedUsers.length == teamUserLimit && teamLabel ? 'btn-success' : 'btn-danger'"
                    (click)="handleSubmit()">Save Team</button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div *ngIf="users?.length">
          <div *ngIf="labels?.length; else noLabel">
            <mat-form-field>
              <mat-label>Team Label</mat-label>
              <mat-select [(ngModel)]="teamLabel" required>
                <mat-option *ngFor="let label of labels" [value]="label">{{label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-template #noLabel><p>No more team labels are available.</p></ng-template>
          <mat-selection-list [(ngModel)]="selectedUsers">
            <mat-list-option *ngFor="let user of users; let i = index"
              class="list-group-item list-group-item-action"
              [class.li-user-alt-bg]="i % 2 == 0"
              [value]="user">
              {{user.firstName}} {{user.lastName}}
            </mat-list-option>
          </mat-selection-list>
          <button type="submit" class="btn mt-3"
                  [ngClass]="selectedUsers.length == teamUserLimit && teamLabel ? 'btn-success' : 'btn-danger'"
                  (click)="handleSubmit()">Save Team</button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-12">
    <div class="card">
      <div class="card-header">
        <div class="font-weight-bold">Active Teams</div>
        <div *ngIf="teams?.length; else noTeams">Click the icon to delete an active team.</div>
        <ng-template #noTeams>No active teams currently exist.</ng-template>
      </div>
      <!-- TODO: Test 2 column word wrapping with long full names-->
      <div class="card-body">
        <ul *ngIf="teams?.length" class="list-group container">
          <li *ngFor="let team of teams; let i = index" class="list-group-item" [class.odp-li-alt-bg]="i % 2 != 0">
            <div class="row">
              <div class="col-7">
                <div *ngFor="let user of team.teamUsers">
                  {{user.firstName}} {{user.lastName}}
                </div>
                <a *ngIf="team.hasTeamQueue" href="" (click)="editQueueClick($event, team.id)">Edit Queue: {{team.teamAbstractCount}} abstracts</a>
              </div>
              <div class="col-5">
                <div class="team-label my-0 float-right">Team {{team.teamLabel}} ({{team.id}})</div>
                <br />
                <button class="fa fa-trash close my-auto" title="Delete team" (click)="handleDeleteTeam(team)"></button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
